import {Button} from "../stories/buttons/button";
import styled from "styled-components";

import React from "react";

export const Continue = ({results, $status, autoContinue}) => {
    let status = $status
    let buttonType,
        buttonText,
        listType


    if (results.risks.length === 0) {
        if (results.content.length > 0) {
            listType = 'reputation'
        }

        buttonType = 'clean';
        buttonText = 'CONTINUE';
    } else {
        listType = 'risks'
        buttonType = 'warn';
        buttonText = 'CONTINUE WITH CAUTION';

    }
    if (results.isSecure === false && results.isFile === true) {
        listType = 'default'
    }
    return (
        <div>
            {results.risks.length > 0 &&
                <AdviceDiv>Visiting the link may harm your computer or cause your personal information to be
                    stolen.</AdviceDiv>}
            {results.risks.length > 0 && <div><AdviceDiv>We recommend that you do not continue.</AdviceDiv>
                <Spacer></Spacer>
            </div>
            }

            {(status === 'clean' || (status === 'warn' && [2, 3, 4, 5].includes(autoContinue) === false)) && listType !== 'default' &&
                <div><Button onClick={() => {
                    window.location.replace(results.url);
                }} label={buttonText} buttonType={buttonType}
                /> <Spacer/></div>
            }

            {results.isSecure === false && results.isFile === true &&
                <div>
                    <WarningDiv>
                        This link is attempting to redirect or download a file from an insecure (HTTP)
                        website.
                    </WarningDiv>
                    <WarningDiv>
                        Due to the insecure link, we are unable to redirect you automatically or provide a Continue
                        button.
                    </WarningDiv>
                </div>
            }

        </div>
    )
}

const AdviceDiv = styled.div`
  text-align: left;
  margin-top: 20px;
`

const WarningDiv = styled.div`
  text-align: left;
  margin-top: 20px;
  color: crimson;
`

const Spacer = styled.div`
  height: 20px`
